import usePersonas from './usePersonas'

// useInsightsPersonas is the persona list for an Insights pane: the
// customer's personas library, Company-level then the user's own (#1523).
// It used to read the dashboard job's merged config, so a dashboard with no
// job offered only the defaults; personas are customer-wide now. Before the
// library loads, or if it fails, the standard personas are offered.
export const useInsightsPersonas = (customer: string): string[] =>
  usePersonas({ customer }).personaNames

export default useInsightsPersonas
